import { ReactNode } from "react";

export default function FieldGroup({ children }: { children: ReactNode }) {
  return <div className="fl-flex fl-flex-col fl-space-y-2">{children}</div>;
}
